'use client'

import type { PropsWithChildren } from 'react'

import { SpaceLayoutClient as SharedSpaceLayoutClient } from '@/components/space/space-layout-client'
import { SceneID } from '@/enums/agent'

interface SpaceLayoutClientProps extends PropsWithChildren {
  defaultOpen?: boolean
}

/**
 * Grok page layout client component.
 * Uses shared SpaceLayoutClient with basePath /grok，默认模型为 GROK（空页锁定，提交后可切换）
 */
export const SpaceLayoutClient = ({ children, defaultOpen = true }: SpaceLayoutClientProps) => {
  return (
    <SharedSpaceLayoutClient
      config={{ basePath: '/grok', defaultModelId: SceneID.GROK }}
      defaultOpen={defaultOpen}
    >
      {children}
    </SharedSpaceLayoutClient>
  )
}
